import React, { Fragment, useEffect, useState } from 'react';
import './../Resources/css/block_theSecret.css'

import Common from '../../../Shared/Common';
import Block from '../../../Controls/Scafolding/Block';

import { Row, Col } from 'reactstrap';
import { ContentWhoAmI1, ContentWhoAmI2, ContentWhoAmI3 } from './_ContentBlocks';
import { TextHeader, TextTitle, TextBock } from '../../../Controls/Digital/TextHeaders';

import imgProfile from '../Resources/Images/product_sample_7.jpg';
import { AnimatedImage } from '../../../Controls/Digital/AnimatedImage';

const TheSecret = (props) =>{

    const [blockName, setBlockName] = useState("");

    useEffect(() => {
        setBlockName(props.name);
        Common.traceInit("Block " + blockName);
    });

    return (
        <Block name="theSecret" isAlt={true}>

            <Row>

                <Col lg="6" className="info">

                    <TextHeader text={
                        <Fragment>
                            Bread & Flour
                        </Fragment>
                    } />

                    <TextTitle text={
                        <Fragment>
                            Meet Leo
                        </Fragment>
                    } />

                    <TextBock addClass="left-text" text={
                        <Fragment>
                            Trained as a chef; he began working in kitchens back in his native Naples where he mastered the use of bread & tomatoes on every dish.
                            Leo moved to Austarlia in 2005; where he has been working first in Sydney and Wollongong Restaurants prior to open run "La Signora Cafe" which has been serving customer in Port Kembla for over 5 years with magnificent ....
                        </Fragment>
                    } />

                    <TextBock addClass="left-text" text={
                        <Fragment>
                            Trained as a chef; he began working in kitchens back in his native Naples where he mastered the use of bread & tomatoes on every dish.
                            Leo moved to Austarlia in 2005; where he has been working first in Sydney and Wollongong Restaurants prior to open run "La Signora Cafe" which has been serving customer in Port Kembla for over 5 years with magnificent ....
                        </Fragment>
                    } />

                </Col>

                <Col lg="6" className="align-self-center">
                    <AnimatedImage image={imgProfile} animation="colorize" />
                </Col>

            </Row>


        </Block>
    );
}
export default TheSecret;
